"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _material = require("@mui/material");
var _TableTextSearchBox = _interopRequireDefault(require("./TableTextSearchBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var EnhancedTableToolbar = /** @class */function (_super) {
  __extends(EnhancedTableToolbar, _super);
  function EnhancedTableToolbar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  EnhancedTableToolbar.prototype.render = function () {
    var _this = this;
    return (0, _jsxRuntime.jsxs)(_material.Toolbar, __assign({
      sx: {
        pl: {
          sm: 2
        },
        pr: {
          xs: 1,
          sm: 1
        }
      }
    }, {
      children: [this.props.headerContent && (0, _jsxRuntime.jsx)(_material.Typography, __assign({
        sx: {
          flex: '1 1 100%'
        },
        style: {
          width: '50%',
          display: 'flex'
        },
        variant: "h6",
        id: "tableTitle",
        component: "div"
      }, {
        children: this.props.headerContent
      })), this.props.showSearch && (0, _jsxRuntime.jsx)("div", __assign({
        style: {
          width: '50%',
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, {
        children: (0, _jsxRuntime.jsx)(_TableTextSearchBox.default, {
          handleUpdateValue: function handleUpdateValue(newValue) {
            return _this.props.onSearch(newValue);
          },
          defaultValue: this.props.defaultSearch,
          showIcon: true,
          sx: {
            width: 275,
            marginRight: 10
          }
        })
      }))]
    }));
  };
  return EnhancedTableToolbar;
}(_react.Component);
var _default = EnhancedTableToolbar;
exports.default = _default;